import dayjs from "dayjs";

export const COMMUNICATION_DATE_FORMAT = "DD.MM.YYYY";
export const COMMUNICATION_DATE_TIME_FORMAT = "DD.MM.YYYY, HH:mm:ss";
export const COMMUNICATION_DATE_TIME_SHORT_FORMAT = "DD.MM.YYYY, HH:mm";

const toCommunicationDayjs = (value?: string | Date | null) => {
  if (!value) {
    return undefined;
  }

  const parsedValue = dayjs(value);
  return parsedValue.isValid() ? parsedValue : undefined;
};

export const formatCommunicationDate = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_FORMAT) || "";

export const formatCommunicationDateTime = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_TIME_FORMAT) || "";

export const formatCommunicationDateTimeShort = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_TIME_SHORT_FORMAT) || "";

export const getCommunicationDayKey = (value?: string | Date | null): string => {
  const parsedValue = value ? toCommunicationDayjs(value) : dayjs();

  if (!parsedValue || !parsedValue.isValid()) {
    return "";
  }

  return parsedValue.format("YYYY-MM-DD");
};
